import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$city/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/kaart',
      search: { city: params.city },
      replace: true,
    });
  },
});
